<section class="parent-profile-settings">
  <div class="children">
    <h5>Ваши дети</h5>
    <br>
    <table mat-table [dataSource]="dataSource" width="100%">
    
      <!-- Position Column -->
      <ng-container matColumnDef="full_name">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user">
          <a href="#">{{ user.name }} {{ user.surname }}</a>
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user">
          <!-- <button mat-icon-button aria-label="Example icon-button with a heart icon" (click)="deleteStudent(user)">
            <mat-icon>delete</mat-icon>
          </button> -->
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <!-- <br> -->
  <!-- <div>
    <button mat-raised-button>Добавить</button>
  </div> -->
</section>